if (window.Ready === undefined) {
  //console.log('[sard_core] app/javascript/shared/ready.js [NEW]')
  const Ready = function(func) {
    let hasRun = false;

    const runOnce = () => {
      if (!hasRun) {
        hasRun = true;
        func();
      }
    };

    // Reset hasRun flag before new page loads
    document.addEventListener('turbo:before-visit', () => {
      hasRun = false;
    });

    // Handle Turbo load
    document.addEventListener('turbo:load', runOnce);

    // Handle regular page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runOnce, { once: true });
    } else {
      // If DOM is already loaded, execute immediately
      runOnce();
    }

    // Fallback for when Turbo is not supported
    if (typeof Turbo === 'undefined' || !Turbo.supported) {
      document.addEventListener('DOMContentLoaded', runOnce, { once: true });
    }
  }
  window.Ready = Ready;
}
